export default __webpack_public_path__ + "static/media/menu1.a4fb598d.svg";